<script>
import { HorizontalBar } from 'vue-chartjs'
import { Bus } from '../../bus'

export default {
  extends: HorizontalBar,
  props: {
    topics: {
      required: true,
      type: Array
    },
    currentTopic: {
      required: false,
      default: function () {
        return { id: '0', backgroundColor: 'rgba(197,17,98,0.2)', borderColor: 'rgba(213,0,0, 1)' }
      },
      type: Object
    }
  },
  computed: {
    terms () {
      return this.topics[this.currentTopic.id].terms
    }
  },
  methods: {
    getChartData () {
      console.log(this.currentTopic)
      return {
        labels: this.terms.map(term => Object.keys(term)[0]),
        datasets: [{
          label: 'Term Frequency for Topic ' + (this.topics[this.currentTopic.id].id),
          data: this.terms.map(term => Object.values(term)[0]),
          backgroundColor: this.currentTopic.backgroundColor,
          borderColor: this.currentTopic.borderColor,
          borderWidth: 1
        }]
      }
    },
    getChartOptions () {
      return {
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    },
    updateChart () {
      let data = this.getChartData()
      let options = this.getChartOptions()

      this.renderChart(data, options)
    },
    getColorsByTopicId (id) {
      const backgroundColors = [
        'rgba(197,17,98,0.2)',
        'rgba(170,0,255,0.2)',
        'rgba(48,79,254,0.2)',
        'rgba(0,145,234,0.2)',
        'rgba(0,191,165,0.2)',
        'rgba(100,221,23,0.2)',
        'rgba(255,214,0,0.2)',
        'rgba(255,109,0,0.2)',
        'rgba(221,44,0,0.2)',
        'rgba(46,61,52,0.2)',
        'rgb(105,105,105, 0.2)'

      ]
      const borderColors = [
        'rgba(197,17,98,1)',
        'rgba(170,0,255,1)',
        'rgba(48,79,254,1)',
        'rgba(0,145,234,1)',
        'rgba(0,191,165,1)',
        'rgba(100,221,23,1)',
        'rgba(255,214,0,1)',
        'rgba(255,109,0,1)',
        'rgba(221,44,0,1)',
        'rgba(46,61,52,1)',
        'rgb(105,105,105,1)'
      ]
      return { backgroundColor: backgroundColors[id], borderColor: borderColors[id] }
    }

  },
  mounted () {
    this.updateChart()
  },
  watch: {
    currentTopic () {
      this.updateChart()
    }
  },

  created () {
    if (this.$route.query.topic) {
      this.currentTopic.id = this.$route.query.topic - 1
      let colors = this.getColorsByTopicId(this.currentTopic.id)
      this.currentTopic.backgroundColor = colors.backgroundColor
      this.currentTopic.borderColor = colors.borderColor
    } else {
      this.currentTopic.id = 0
    }
    Bus.$on('topic-clicked', (topic) => {
      console.log(topic)
      this.currentTopic.id = topic.id
      this.currentTopic.backgroundColor = topic.backgroundColor
      this.currentTopic.borderColor = topic.borderColor
      this.updateChart()
    })
  }
}
</script>
